<template>
  <div class="notify-container" ref="notify">
    <div class="notify-miniature pointer" @click="openNotifies">
      <div class="notify-icon"></div>
      <div class="notify-new" v-if="hasNew"></div>
<!--      <div class="notify-count">99</div>-->
    </div>
    <div v-if="opened" class="dropdown-backdrop" @click="opened = false"></div>
    <div class="notify-block" v-if="opened">
      <div class="notify-header">Уведомления</div>
      <template v-if="$store.state.notifications.notifications.length > 0">
        <div class="notify-list">
          <div class="notify pointer" :class="{new: notify.read_at == null}" v-for="notify in $store.state.notifications.notifications" :key="notify.id" @click="read(notify)">
            <div class="notify-title">{{notify.title}}</div>
            <div class="notify-text" v-html="notify.message"></div>
            <div class="notify-date">{{notify.created_at}}</div>
            <div class="close-icon" @click="deleteNotification(notify)"></div>
          </div>
        </div>
        <router-link style="padding: 10px 20px; border-top: 1px solid #D9D9D9FF;" to="/notifications" @click="opened = false;">Посмотреть все</router-link>
      </template>
      <div class="notify-no-content" v-else>У Вас нет уведомлений</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notifyManager",
  data() {
    return {
      opened: false,
      page: 1,
      autoupdate: '',
    }
  },
  mounted() {
    this.updateNotifies();
    document.addEventListener('click', this.closeInactive)
    this.autoupdate = setInterval(()=> {
      this.updateNotifies();
    }, 10000)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeInactive)
  },
  computed: {
    hasNew() {
      return this.$store.state.notifications.notifications.some((item) => {
        if(item.read_at != null) {
          return false;
        } else {
          return true;
        }
      });
    }
  },
  methods: {
    read(item) {
      if(item.read_at == null) {
        this.$store.dispatch('NOTIFICATIONS_READ', item);
      }
    },
    updateNotifies() {
      this.$store.dispatch('NOTIFICATIONS_UPDATE', this.page);
    },
    deleteNotification(notify) {
      this.$store.dispatch('NOTIFICATIONS_DELETE', notify.id);
    },
    closeInactive(evt) {
      var path = (evt.composedPath && evt.composedPath()) || evt.path;
      for(let i = 0; i < path.length; i++) {
        if(path[i] === this.$refs.notify) {
          return;
        }
      }
      this.opened = false;
    },
    openNotifies() {
      this.opened = true;
    }
  }
}
</script>

<style scoped>
.close-icon:hover {
  opacity: 1;
}
.close-icon {
  opacity: .6;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='12' viewBox='0 0 10 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.02638 10.756L4.79689 7.36501L1.56837 10.756C1.39635 10.9325 1.16437 11.0301 0.923842 11.0287C0.683318 11.0273 0.453362 10.9263 0.283217 10.7478C0.113072 10.5693 0.0171601 10.3277 0.0156392 10.0751C0.0141184 9.82257 0.107423 9.58014 0.275405 9.39938L3.50392 6.00842L0.275405 2.61848C0.18891 2.52972 0.119512 2.42366 0.0722799 2.30676C0.0250476 2.18985 0.000685404 2.06358 1.42519e-05 1.93659C-0.0006569 1.80961 0.02238 1.68387 0.0683736 1.56643C0.114367 1.44898 0.182041 1.34242 0.267592 1.25266C0.353144 1.1629 0.454531 1.09168 0.56642 1.04348C0.67831 0.995274 0.798997 0.970896 0.919936 0.971699C1.04087 0.972502 1.1602 0.998919 1.2715 1.0486C1.3828 1.09829 1.48391 1.171 1.56837 1.26188L4.79689 4.65183L8.02638 1.26188C8.1984 1.08536 8.42941 0.986704 8.66993 0.988105C8.91046 0.989507 9.14041 1.09055 9.31056 1.26906C9.4807 1.44758 9.57759 1.68917 9.57911 1.94172C9.58064 2.19427 9.48733 2.43772 9.31935 2.61848L6.08986 6.00842L9.31935 9.39938C9.48733 9.58014 9.58064 9.82257 9.57911 10.0751C9.57759 10.3277 9.4807 10.5693 9.31056 10.7478C9.14041 10.9263 8.91046 11.0273 8.66993 11.0287C8.42941 11.0301 8.1984 10.9325 8.02638 10.756Z' fill='%23CCCCCC'/%3E%3C/svg%3E%0A");
  width: 10px;
  height: 12px;
  position: absolute;
  right: 20px;
  top: 20px;
}
.notify-no-content {
  padding: 20px;
}
.notify-header {
  padding: 20px;
  font-size: 18px;
  border-bottom: 1px solid #d9d9d9;
}
.notify-title {
  font-size: 16px;
  color: #00cccc;
  padding-bottom: 5px;
}
.notify-new {
  width: 8px;
  height: 8px;
  background-color: #d65959;
  border-radius: 50%;
  position: absolute;
  top: 14px;
  right: -5px;
}
.notify-block {
  z-index: 9;
  position: absolute;
  top: 30px;
  right: -20px;
  width: 600px;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 3px;
  box-shadow: 0 4px 16px rgb(0 0 0 / 10%);
}

.notify-date {
  font-size: 12px;
  color: #8f8f8f;
  font-weight: 600;
}
.dropdown-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 8;
}
.notify.new {
  border: 1px solid #00cccc;
}
.notify {
  position: relative;
  border: 1px solid transparent;
  background: #f5f5f5;
  padding: 15px;
  margin-top: 10px;
  border-left: 5px;
  margin-right: 5px;
  border-radius: 6px;
  margin-bottom: 10px;
}
.notify-miniature {
  width: 20px;
  height: 20px;
  display: flex;
  position: relative;
}

.notify-icon {
  background-image: url("data:image/svg+xml,%3Csvg width='21' height='16' viewBox='0 0 21 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.7201 3.63C16.4314 3.15947 16.0333 2.76558 15.5598 2.48181C15.0863 2.19803 14.5512 2.03275 14.0001 2V0C14.8701 0.0328349 15.7194 0.274372 16.4765 0.704246C17.2336 1.13412 17.8762 1.73973 18.3501 2.47C19.4572 4.09907 20.0336 6.03062 20.0001 8C20.0336 9.96938 19.4572 11.9009 18.3501 13.53C17.8762 14.2603 17.2336 14.8659 16.4765 15.2958C15.7194 15.7256 14.8701 15.9672 14.0001 16V14C14.5512 13.9673 15.0863 13.802 15.5598 13.5182C16.0333 13.2344 16.4314 12.8405 16.7201 12.37C17.584 11.0787 18.0308 9.55334 18.0001 8C18.0308 6.44666 17.584 4.92133 16.7201 3.63ZM9.36013 1.23C9.50545 1.10874 9.68221 1.03122 9.86984 1.00644C10.0575 0.981655 10.2483 1.01063 10.4201 1.09C10.5937 1.17033 10.7406 1.29876 10.8434 1.46005C10.9462 1.62134 11.0006 1.80873 11.0001 2V13.5C11.0006 13.6913 10.9462 13.8787 10.8434 14.0399C10.7406 14.2012 10.5937 14.3297 10.4201 14.41C10.2483 14.4894 10.0575 14.5183 9.86984 14.4936C9.68221 14.4688 9.50545 14.3913 9.36013 14.27L6.55013 11.92L6.16013 13.49C6.05102 13.9218 5.80094 14.3047 5.44953 14.5783C5.09811 14.8518 4.66545 15.0002 4.22013 15H2.80013C2.49066 15.0095 2.18322 14.947 1.90202 14.8174C1.62081 14.6878 1.37353 14.4948 1.17965 14.2534C0.985759 14.012 0.850564 13.7289 0.784706 13.4264C0.718848 13.1238 0.724127 12.8101 0.800127 12.51L1.21013 10.86C0.847348 10.704 0.538854 10.4442 0.323524 10.1132C0.108195 9.78219 -0.00433121 9.39485 0.000127554 9V6.5C0.000127554 5.96957 0.21084 5.46086 0.585912 5.08579C0.960985 4.71071 1.46969 4.5 2.00013 4.5H5.00013C5.12968 4.48477 5.26057 4.48477 5.39013 4.5L9.36013 1.23ZM7.00013 6.5V9.69L9.00013 11.36V4.14L7.00013 5.81V6.5ZM5.00013 6.5H2.00013V9H5.00013V6.5ZM3.28013 11H4.72013L4.22013 13H2.80013L3.28013 11ZM13.0001 6C13.1101 6 13.3401 6.07 13.5801 6.43C13.8685 6.90194 14.0143 7.44713 14.0001 8C14.0143 8.55287 13.8685 9.09806 13.5801 9.57C13.3401 9.93 13.1101 10 13.0001 10V12C13.4538 11.9836 13.8962 11.8543 14.2874 11.6238C14.6785 11.3933 15.0059 11.0689 15.2401 10.68C15.7506 9.88045 16.0149 8.94851 16.0001 8C16.0149 7.05149 15.7506 6.11955 15.2401 5.32C15.0059 4.93108 14.6785 4.6067 14.2874 4.37621C13.8962 4.14573 13.4538 4.01642 13.0001 4V6Z' fill='url(%23paint0_linear_2426_2006)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_2426_2006' x1='10.0008' y1='0' x2='10.0008' y2='16' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2337C489'/%3E%3Cstop offset='1' stop-color='%2300CCCC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
  width: 20px;
  height: 16px;
}

.notify-count {
  position: absolute;
  bottom: -5px;
  right: -5px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  border-radius: 50%;
  background: linear-gradient(180deg, #37C489 0%, #00CCCC 100%);
}

.notify-list {
  padding-left: 5px;
  padding-right: 5px;
  max-height: 460px;
  overflow-y: auto;
}

.notify-container {
  position: relative;
}

</style>